"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Graph = exports.Node = void 0;
var error_messages_1 = require("../constants/error-messages");
/**
 * 图结构的基本节点
 */
var Node = /** @class */ (function () {
    function Node(data) {
        this.incoming = new Map();
        this.outgoing = new Map();
        this.data = data;
    }
    return Node;
}());
exports.Node = Node;
var Graph = /** @class */ (function () {
    function Graph(identifier) {
        this.identifier = identifier;
        this.innerNodes = new Map();
        // Keep empty
    }
    /**
     * 获取图结构的叶子节点(没有子节点)
     */
    Graph.prototype.roots = function () {
        var ret = [];
        this.innerNodes.forEach(function (node) {
            if (node.outgoing.size === 0) {
                ret.push(node);
            }
        });
        return ret;
    };
    /**
     * 在图结构中插入一条边
     * @param from
     * @param to
     */
    Graph.prototype.insertEdge = function (from, to) {
        var fromNode = this.lookupOrInsertNode(from);
        var toNode = this.lookupOrInsertNode(to);
        fromNode.outgoing.set(this.identifier.hashId(to), toNode);
        toNode.incoming.set(this.identifier.hashId(from), fromNode);
    };
    /**
     * 删除图结构的一个节点
     * @param data
     */
    Graph.prototype.removeNode = function (data) {
        var key = this.identifier.hashId(data);
        this.innerNodes.delete(key);
        this.innerNodes.forEach(function (node) {
            node.outgoing.delete(key);
            node.incoming.delete(key);
        });
    };
    /**
     * 检查图中是否存在节点，如果不存在则插入节点
     * @param data
     */
    Graph.prototype.lookupOrInsertNode = function (data) {
        var key = this.identifier.hashId(data);
        var node = this.innerNodes.get(key);
        if (!node) {
            node = new Node(data);
            this.innerNodes.set(key, node);
        }
        return node;
    };
    /**
     * 查询图结构中的节点
     * @param data
     */
    Graph.prototype.lookup = function (data) {
        return this.innerNodes.get(this.identifier.hashId(data));
    };
    /**
     * 判断图是否为空
     */
    Graph.prototype.isEmpty = function () {
        return this.innerNodes.size === 0;
    };
    /**
     * 深度优先遍历
     */
    // 非递归版本的深度优先遍历，逻辑上很难拆分，暂时忽略这里的圈复杂度
    Graph.prototype.dfs = function (data, callback) {
        var graph = this.clone();
        var stack = [];
        var rootNode = graph.innerNodes.get(graph.identifier.hashId(data));
        if (!rootNode) {
            return;
        }
        stack.push(rootNode);
        var walkLoops = 0;
        while (stack.length) {
            if (walkLoops > 10000) {
                // 遍历了一万次？极有可能是有循环依赖
                throw new Error(error_messages_1.GRAPH_CYCLIC_DEPENDENCY);
            }
            walkLoops += 1;
            var topNode = stack[stack.length - 1];
            topNode.outgoing.forEach(function (node) {
                stack.push(node);
            });
            if (!topNode.outgoing.size) {
                if (graph.lookup(topNode.data)) {
                    callback(topNode.data);
                    graph.removeNode(topNode.data);
                }
                stack.pop();
            }
        }
    };
    /**
     *  浅层复制图结构
     */
    Graph.prototype.clone = function () {
        var graph = new Graph(this.identifier);
        this.innerNodes.forEach(function (curNode) {
            curNode.outgoing.forEach(function (outNode) {
                graph.insertEdge(curNode.data, outNode.data);
            });
        });
        return graph;
    };
    /**
     * dump输出图结构的，便于开发调试
     */
    Graph.prototype.toString = function () {
        var _this = this;
        var data = [];
        this.innerNodes.forEach(function (value) {
            var target = _this.identifier.hashString(value.data);
            var incomings = [];
            value.incoming.forEach(function (item) {
                incomings.push(_this.identifier.hashString(item.data));
            });
            var outgoings = [];
            value.outgoing.forEach(function (item) {
                outgoings.push(_this.identifier.hashString(item.data));
            });
            data.push(target + ", (incoming)[" + incomings.join(', ') + "], (outgoing)[" + outgoings.join(', ') + "]");
        });
        return data.join('\n');
    };
    return Graph;
}());
exports.Graph = Graph;
//# sourceMappingURL=graph.js.map